// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-table th.invoice_address,\n.el-table td.invoice_address {\n  width: 15em;\n}", ""]);
// Exports
module.exports = exports;
